export default {
  requestReturn: 'Request Warehouse Return',
  requestScrapping: 'Request Scrapping',
  batchReturn: 'Batch Warehouse Return',
  batchScrapping: 'Batch Scrapping',
  productOffshelfForScrap: 'Products must be taken off the shelves before a scrap request can be submitted',
  productOffshelfForReturn: 'Products must be taken off the shelves before a warehouse return pickup can be requested',
  all: 'All',
  warehouseProductNumber: 'Warehouse Product Number',
  warehouseNumber: 'Warehouse Number',
  warehouseName: 'Warehouse Name',
  productName: 'Product Name',
  productImage: 'Product Image',
  productSpecifications: 'Product Specifications',
  availableInventory: 'Available Inventory Quantity',
  returnQuantity: 'Return Quantity',
  pickupMethod: 'Pickup Method',
  selfPickup: 'Self-Pickup at Warehouse',
  estimatedCollectionTime: 'Estimated Collection Time',
  confirm: 'Confirm',
  cancel: 'Cancel',
  applicationSuccess: 'Application Successfully',
  promptPickup: 'Please proceed to the warehouse for pickup promptly',
  // 打印页面相关
  pleasePickupPromptly: 'Please go to the warehouse to pick up promptly',
  orderNumber: 'Order Number',
  warehouseContact: 'Warehouse Contact',
  contactPhone: 'Contact Phone',
  warehouseAddress: 'Warehouse Address',
  printVoucher: 'Print Voucher',
  downloadPickupVoucher: 'Download Pickup Voucher',
  returnApplicationSubmittedSuccessfully: 'Return Application Submitted Successfully',
  scrapApplicationSubmittedSuccessfully: 'Scrap Application Submitted Successfully',
  returnDetails: 'Return Details',
  scrapDetails: 'Scrap Details',
  express: 'Express',
  homeDelivery: 'Home Delivery',
  other: 'Other',
  unknownMethod: 'Unknown Method',
  generatingImage: 'Generating image, please wait...',
  returnVoucherFilename: 'Application_Voucher.png',
  imageGeneratedSuccessfully: 'Image generated successfully',
  generateImageFailed: 'Failed to generate image, please try again',
  featureOnlyAvailableInClient: 'This feature is only available in client',
  downloadImageFailed: 'Failed to download image',
  preparingToPrint: 'Preparing to print, please wait...',
  status: 'Status',
  pendingReview: 'Pending Review',
  pendingProcessing: 'Pending Processing',
  pendingPickup: 'Pending Receive',
  completed: 'Completed',
  cancelled: 'Cancelled',
  contactPerson: 'Contact Person',
  // 表格相关
  returnNumber: 'Return Number',
  returnOrderNumber: 'Return Customer Order Number',
  requestReturnQuantity: 'Requested Return Quantity',
  actualOutboundQuantity: 'Actual Outbound Quantity',
  estimatedPickupTime: 'Estimated Pickup Time',
  returnCompletionTime: 'Return Completion Time',
  printPickupVoucher: 'Print Pickup Voucher',
  unknownStatus: 'Unknown Status',
  printSlip: 'Print pickup Slip',
  viewApplicationList: 'View Application List',
  returnApplicationRecords: 'Warehouse Return Application Records',
  batchPrintSlip: 'Batch Print pickup Slip',
  scrapApplicationRecords: 'Scrap Application Records',
  scrapOrderNumber: 'Scrap Customer Order Number (SO-reference)',
  pendingReceive: 'Warehouse Pending Pickup',
  selectProducts: 'Please select products to apply',
  selectPickupTime: 'Please select estimated pickup time',
  enterProductQuantity: 'Please enter product quantity',
  returnTip: 'Please collect your items with the printed return slip from Mon-Fri (Kenya time: 8:00-12:00 & 13:00-15:00). Once submitted, the request cannot be canceled. Uncollected slips will expire. Do you confirm to proceed?',
  scrapTip: 'All FBK delisted stock for this SKU will be permanently disposed of (excluding future returns). Storage fees will stop the day after completion. This request is irreversible. Do you confirm disposal?',
  iAgree: 'I agree Terms & Conditions',
  inventoryCannotBeZero: 'Inventory cannot be zero',
  agreeToTerms: 'I agree to the rules and terms',
  confirmReturn: 'Confirm Return',
  confirmScrap: 'Confirm Scrap',
  selectWarehouse: 'Please select warehouse',
  enterFrontSku: 'Please enter front SKU',
  enterListingId: 'Please enter Listing ID',
  search: 'Search',
  scrapNumber: 'Scrap Number',
  scrapQuantity: 'Scrap Quantity',
  applicationTime: 'Application Time',
  completionTime: 'Completion Time',
  operation: 'Operation',
  details: 'Details',
  startTime: 'Start Time',
  endTime: 'End Time',
  batchPrintVoucher: 'Batch Print Voucher',
  viewScrapList: 'View Scrap List',
  viewReturnList: 'View Return List',
  nonOffShelfProductsFiltered: 'Non-off-shelf products have been filtered',
  productNotOffShelf: 'Product not off shelf',
  pickupRules: 'Pickup Rules'
}
